module.exports = __webpack_public_path__ + "static/media/logo-arom@2x.5f6911be.png";